import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";

const STAGES = ["Reading your CV", "Reading the job ad", "Comparing your experience with the job", "Writing your tailored CV and cover letter", "Checking nothing was made up"];

export default function TailorProgress({ role }) {
  const [i, setI] = useState(0);
  const [secs, setSecs] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setSecs((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => { setI(Math.min(STAGES.length - 1, Math.floor(secs / 12))); }, [secs]);
  return (
    <div className="gi-card p-6 sm:p-8 af-fade-up" data-testid="tailor-progress" aria-live="polite">
      <h2 className="font-display text-xl font-bold text-ink">Tailoring your CV{role ? ` for ${role}` : ""}…</h2>
      <p className="text-body mt-1">This usually takes about a minute. You can leave this page. We'll keep working, and it'll be waiting in Applications.</p>
      <ol className="mt-6 space-y-3">
        {STAGES.map((s, n) => (
          <li key={s} className={`flex items-center gap-3 text-[15px] ${n <= i ? "text-ink" : "text-faint"}`}>
            <span className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 ${n < i ? "bg-brand-soft text-brand-text" : n === i ? "bg-brand text-onbrand" : "bg-subtle"}`}>
              {n < i ? <Check className="w-3.5 h-3.5" /> : n === i ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : null}
            </span>
            {s}
          </li>
        ))}
      </ol>
      <div className="mt-6 h-1.5 rounded-full bg-subtle overflow-hidden" aria-hidden="true">
        <div className="h-full bg-brand rounded-full transition-[width] duration-1000" style={{ width: `${Math.min(95, (secs / 75) * 100)}%` }} />
      </div>
    </div>
  );
}
